<!-- =========================================================================================
  File Name: ClientEditTabInfo.vue
  Description: Client Edit Tab Info page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.auth-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.button-wrap {
  text-align: right;
  margin-top: 20px;
}

.vs-con-textarea {
  margin-bottom: 0px;
}
.domain-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.domain-name {
  margin-left: 10px;
}
</style>
<template>
  <div id="client-edit-tab-info">
    <h3 class="my-5">Client Details</h3>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mt-4">
        <vs-input
          class="w-full"
          label="Company Name"
          v-validate="'required'"
          name="ClientName"
          v-model="data_local.ClientName"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('ClientName')"
        >{{ errors.first('ClientName') }}</span>
      </div>
      <div class="vx-col sm:w-1/2 w-full mt-4">
        <div class="domain-wrapper">
          <vs-input
            class="w-full"
            label="Custom Domain"
            name="CustomDomain"
            v-model="data_local.CustomDomain"
            v-validate="'required'"
            maxlength="50"
          />
          <label v-show="showE2MLive" class="domain-name">.e2m.live</label>
        </div>
        <span
          class="text-danger text-sm"
          v-show="errors.has('CustomDomain')"
        >{{ errors.first('CustomDomain') }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full mt-4">
        <span class="w-full vs-input--label">Company Profile</span>
        <vs-textarea v-model="data_local.Company" />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mt-4">
        <vs-input
          class="w-full"
          label="Client Admin First Name"
          v-validate="'required'"
          name="UserFirstName"
          v-model="data_local.UserFirstName"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('UserFirstName')"
        >{{ errors.first('UserFirstName') }}</span>
      </div>
      <div class="vx-col sm:w-1/2 w-full mt-4">
        <vs-input
          class="w-full"
          label="Client Admin Last Name"
          v-validate="'required'"
          name="UserLastName"
          v-model="data_local.UserLastName"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('UserLastName')"
        >{{ errors.first('UserLastName') }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mt-4">
        <vs-input
          :readonly="!data_local.EmailEditable"
          class="w-full"
          label="Client Admin Email"
          v-validate="'required'"
          name="ClientEmail"
          v-model="data_local.ClientEmail"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('ClientEmail')"
        >{{ errors.first('ClientEmail') }}</span>
      </div>
      <!-- <div class="vx-col sm:w-1/2 w-full mt-4" v-if="!$route.params.clientId">
        <vs-input
          :readonly="!data_local.Editable"
          class="w-full"
          label="Client Admin Password"
          v-validate="'required|min:4'"
          name="Password"
          v-model="data_local.Password"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Password')"
        >{{ errors.first('Password') }}</span>
      </div> -->
      <div class="vx-col sm:w-1/2 w-full mt-4">
        <vs-input
          :readonly="!data_local.EventCountEditable"
          type="number"
          min="1"
          max="999"
          class="w-full"
          label="Event Licenses"
          v-validate="'required|integer|min_value:1|max_value:999'"
          name="EventCount"
          v-model="data_local.EventCount"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('EventCount')"
        >{{ errors.first('EventCount') }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-8">
        <div class="auth-check">
          <label class="mr-5 mt-2">Allow Registration</label>
          <vs-switch v-model="data_local.AllowRegister" name="AllowRegister">
          </vs-switch>
        </div>
      </div>
      
      <div class="vx-col md:w-1/2 w-full mt-8">
        <div class="auth-check">
          <label class="mr-5 mt-2">Enable Email only Login</label>
          <vs-switch v-model="data_local.EnableEmailOnlyLogin" name="EnableEmailOnlyLogin">
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
      </div>

        <div class="vx-col md:w-1/2 w-full mt-8">
        <div class="auth-check">
          <label class="mr-5 mt-2">Enable Self Service</label>
          <vs-switch v-model="data_local.EnableSelfService" name="EnableSelfService">
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
      </div>
    </div>
    <div class="vx-row button-wrap">
      <div class="vx-col sm:w-2/3 w-full ml-auto">
        <vs-button class="mr-3 mb-2" @click="before_save">Save</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="reset_data">Reset</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
export default {
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      Password: null,
    };
  },
  computed: {
    showE2MLive: function () {
      return this.data_local.CustomDomain.indexOf(".") == -1;
    },
  },
  watch: {
    //showE2M: function () {
    //  alert(this.data_local.CustomDomain);
    //  return this.data_local.CustomDomain.indexOf(".") != -1;
    //},
  },
  methods: {
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    save_changes() {
      if (this.$route.params.clientId > -1) {
        return;
      }
      this.$vs.loading();
      let clientId = this.$route.params.clientId;
      if (clientId) {
        this.$store
          .dispatch("clientManagement/updateClient", {
            id: clientId,
            data: this.data_local,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Client",
              text: res.message,
            });
            this.$vs.loading.close();
          });
      } else {
        this.$store
          .dispatch("clientManagement/addClient", { data: this.data_local })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              title: "Client",
              text: res.message,
            });
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$router.push('/client/list');
              /*this.$router.push({
                name: "client-edit",
                params: {
                  clientId: res.Id,
                },
              });*/
            }
          });
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc = this.data.ProfilePictureURL;
    },
  },
};
</script>